import { render, staticRenderFns } from "./right-sheet.vue?vue&type=template&id=dc63e4ea&scoped=true&"
import script from "./right-sheet.vue?vue&type=script&lang=js&"
export * from "./right-sheet.vue?vue&type=script&lang=js&"
import style0 from "./right-sheet.vue?vue&type=style&index=0&id=dc63e4ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc63e4ea",
  null
  
)

export default component.exports